<template>
  <div>
    <div class="row no-gutters">
      <div class="col-sm-4 d-flex align-items-center justify-content-around">
        <h2>Beta</h2>
      </div>
      <!-- Logo -->
      <div class="col-sm-4 d-flex align-items-center justify-content-around">
        <img class="imageSize" src="../assets/logo.png" alt="Logo" />
      </div>
      <!-- Date et Heure -->
      <div
        class="col-12 col-sm-4 d-flex align-items-center justify-content-around"
      >
        {{ datefr }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "logo",
  data() {
    return {
      datefr: ""
    };
  },
  methods: {
    dateFr() {
      // les noms de jours / mois
      let jours = new Array(
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      );
      let mois = new Array(
        "janvier",
        "fevrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "aout",
        "septembre",
        "octobre",
        "novembre",
        "decembre"
      );
      // on recupere la date
      let date = new Date();
      // on construit le message
      let message = jours[date.getDay()] + " "; // nom du jour
      message += date.getDate() + " "; // numero du jour
      message += mois[date.getMonth()] + " "; // mois
      message += date.getFullYear();
      let isDat = this;
      setInterval(() => {
        isDat.datefr = message + " " + new Date().toLocaleTimeString();
      }, 1000);
    }
  },
  mounted() {
    this.dateFr();
  }
};
</script>
